export const setNameDay = ( date ) => {
  const formatDate = date.replaceAll('-','/')
  const dayNUmber = new Date(formatDate).getDay();
  switch ( dayNUmber ) {
    case 0:
      return 'Domingo';
    case 1:
      return 'Lunes';
    case 2:
      return 'Martes';
    case 3:
      return 'Miércoles';
    case 4:
      return 'Jueves';
    case 5:
      return 'Viernes';
    case 6:
      return 'Sábado';
  }
}
export const setFullTextDate = ( date ) => {
  const formatDate = date.replaceAll('-','/')
  const dayNumber = date.split('-')[2];
  // const dayNumber = new Date(formatDate).getDay();
  const monthNumber = new Date(formatDate).getMonth();
  let  month, fullDate;

  switch ( monthNumber ) {
    case 0:
      month = 'Enero';
      break
    case 1:
      month = 'Febrero';
      break
    case 2:
      month = 'Marzo';
      break
    case 3:
      month = 'Abril';
      break
    case 4:
      month = 'Mayo';
      break
    case 5:
      month = 'Junio';
      break
    case 6:
      month = 'Julio';
      break
    case 7:
      month = 'Agosto';
      break
    case 8:
      month = 'Septiempre';
      break
    case 9:
      month = 'Octubre';
      break
    case 10:
      month = 'Noviembre';
      return
    case 11:
      month = 'Diciembre';
      break
  }

  fullDate = `${dayNumber} de ${month} de ${formatDate.split('/')[0]}`
  return fullDate
}

